import Vue from 'vue'
import Vuex from 'vuex'
import { DEFAULT_API_BASE, STORAGE_KEYS } from '@/utils/constants'

Vue.use(Vuex)

function loadUser() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.user) || 'null')
  } catch (error) {
    return null
  }
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(STORAGE_KEYS.token) || '',
    user: loadUser(),
    apiBase: localStorage.getItem(STORAGE_KEYS.apiBase) || DEFAULT_API_BASE,
  },
  getters: {
    isAuthenticated: (state) => Boolean(state.token && state.user),
    role: (state) => (state.user || {}).role || '',
  },
  mutations: {
    SET_SESSION(state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem(STORAGE_KEYS.token, token)
      localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user))
    },
    CLEAR_SESSION(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem(STORAGE_KEYS.token)
      localStorage.removeItem(STORAGE_KEYS.user)
    },
    SET_API_BASE(state, apiBase) {
      state.apiBase = apiBase.trim().replace(/\/$/, '')
      if (state.apiBase) localStorage.setItem(STORAGE_KEYS.apiBase, state.apiBase)
      else localStorage.removeItem(STORAGE_KEYS.apiBase)
    },
  },
})
